<template>
    <el-dialog title="编辑会员资料" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small" :model="form">
            <el-form-item label="昵称" :label-width="formLabelWidth">
                <el-input v-model="form.nickName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="会员编号" :label-width="formLabelWidth">
                <el-input v-model="form.user_no" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="手机号" :label-width="formLabelWidth">
                <el-input v-model="form.mobile" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="密码" :label-width="formLabelWidth">
                <el-input v-model="password_val" autocomplete="off" type="password" placeholder="不输入则不修改密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" :label-width="formLabelWidth">
                <el-input v-model="password_val2" autocomplete="off" type="password" placeholder="请确认新密码"></el-input>
            </el-form-item>
            <el-form-item label="等级" :label-width="formLabelWidth">
              <el-select v-model="form.grade_id" placeholder="-请选择等级-">
                <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="地址"  :label-width="formLabelWidth" prop="address" :rules="[{required: true,message: ' '}]">
                  <el-input v-model="form.address" :disabled="true" placeholder="请输入地址" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="坐标" :label-width="formLabelWidth">
            <el-row class="mb16">
            <el-col :span="24">
                <el-input :disabled="true" v-model="form.coordinate" class="max-w460"></el-input>
            </el-col>
            </el-row>
            <el-row class="mb16">
            <el-col :span="24">
                <Getpoint :form="form"  @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
            </el-col>
            </el-row>

        </el-form-item>


            <el-form-item label="会员到期时间" :label-width="formLabelWidth">
              <el-date-picker v-model="form.expire_date_text" type="datetime" placeholder="选择日期时间" align="right" :picker-options="timePickerOpt"></el-date-picker>
              <p class="gray">会员到期时间到了,会员等级自动降级到 [{{ gradeList[0].name }}]</p>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import UserApi from '@/api/user.js';
    import Getpoint from '@/components/map/Getpoint.vue';
    export default {
        components: {
            Getpoint,
        },
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                /* 城市锁 */
                lock_city:true,
                /* 区域锁 */
                lock_region:true,
                province_options:{},
                city_options:{},
                region_options:{},
                password_val:'',
                password_val2:'',
                // 会员到期时间选择器左侧快捷选项
                timePickerOpt: {
                shortcuts: [{
                  text: '一年',
                  onClick(picker) {
                    const date = new Date()
                    date.setFullYear(date.getFullYear() + 1)
                    picker.$emit('pick', date)
                  }
                }, {
                  text: '两年',
                  onClick(picker) {
                    const date = new Date()
                    date.setFullYear(date.getFullYear() + 2)
                    picker.$emit('pick', date)
                  }
                }, {
                  text: '三年',
                  onClick(picker) {
                    const date = new Date()
                    date.setFullYear(date.getFullYear() + 3)
                    picker.$emit('pick', date)
                  }
                }]
              },
            };
        },
        props: ['open_kmd','form', 'gradeList'],
        created() {
            console.log(this.form)
            if(!this.form.coordinate){
                this.form.coordinate = "";
            }
            if(!this.form.address){
                this.form.address = "";
            }
            this.dialogVisible = this.$parent.open_kmd;
        },
        methods: {
   
        
             /*选择的地址*/
            choseFunc(e){
                console.log("触发了吗",e)
                this.form.coordinate=e.location.lat+','+e.location.lng;
                this.form.address=e.address;
                this.$forceUpdate();
            },
            /*获取经纬度*/
            getMapdataFunc(e) {
                this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
                this.$forceUpdate();
            },    
            editUser(){
                let self = this;
                self.loading = true;
                let params = self.form;
                if(self.password_val != ''){
                    if(self.password_val2 == ''){
                        self.$message({
                            message: '请确认新密码',
                            type: 'info'
                        });
                        self.loading = false;
                        return false;
                    }

                    if(self.password_val != self.password_val2){
                        self.$message({
                            message: '密码不一致',
                            type: 'info'
                        });
                        self.loading = false;
                        return false;
                    }

                    params.password = self.password_val
                }


                UserApi.editAdd(params,true)
                    .then(data => {
                        self.loading = false;
                        if (data.code == 1) {
                            self.$message({
                                message: '恭喜你，用户修改成功',
                                type: 'success'
                            });
                            self.dialogFormVisible(true);
                        }
                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Edit.vue